import { createFileRoute, Navigate } from '@tanstack/react-router';

/** «Presenze per sede» è la scheda «Per sede» di «Presenze del personale» dal 03-11-2026: l'indirizzo resta per i segnalibri. */
export const Route = createFileRoute('/_app/workforce/site-presences')({
  component: () => <Navigate to="/hr/presence" search={{ tab: 'sites' }} replace />,
});
